import axios from "axios";
import React, { useState, useEffect } from "react";
import { Card, Form, Row, Col, Button, Table, Modal } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";

const BASE_URL = "https://sutmmg.codydeasoftech.in/api";

const CircleMaster = () => {
  const [showModal, setShowModal] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [editId, setEditId] = useState(null);
  const [subDivisions, setSubDivisions] = useState([]);
      const [districts, setDistricts] = useState([]);
  const [municipalityList, setMunicipalityList] = useState([]);
  const [circleList, setcircleList] = useState([]);
const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
    const [totalRecords, setTotalRecords] = useState(0);
    const [totalPages, setTotalPages] = useState(1);
    const [filterSubDivisions, setFilterSubDivisions] = useState([]);
const [modalSubDivisions, setModalSubDivisions] = useState([]);


  const [filters, setFilters] = useState({
    searchKey: "",
      district_id: "",

  });

  const [formData, setFormData] = useState({
    district_id: "",
    sub_division_id: "",
    circle_name: "",
  });

  const navigate = useNavigate();

  const getAuthHeader = () => ({
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
  });




const fetchFilterSubDivisions = async (districtId) => {
  if (!districtId) {
    setFilterSubDivisions([]);
    return;
  }

  const res = await axios.post(
    `${BASE_URL}/subDivisionList`,
    { district_id: districtId },
    getAuthHeader()
  );

  setFilterSubDivisions(res.data?.data || []);
};

const fetchModalSubDivisions = async (districtId) => {
  if (!districtId) {
    setModalSubDivisions([]);
    return;
  }

  const res = await axios.post(
    `${BASE_URL}/subDivisionList`,
    { district_id: districtId },
    getAuthHeader()
  );

  setModalSubDivisions(res.data?.data || []);
};



useEffect(() => {
  fetchFilterSubDivisions(filters.district_id);
}, [filters.district_id]);

useEffect(() => {
  if (!formData.district_id) return;

  // Only fetch for adding new circle or when district changes in add mode
  if (!isEdit) {
    fetchModalSubDivisions(formData.district_id);
  }
}, [formData.district_id, isEdit]);





  const getPageNumbers = () => {
  const pages = [];
  const maxPagesToShow = 5;

  let start = Math.max(1, page - 2);
  let end = Math.min(totalPages, start + maxPagesToShow - 1);

  if (end - start < maxPagesToShow - 1) {
    start = Math.max(1, end - maxPagesToShow + 1);
  }

  for (let i = start; i <= end; i++) {
    pages.push(i);
  }

  return pages;
};


  const fetchCircleList = async (
  pageNo = 1,
  searchValue = filters.searchKey,
  districtId = filters.district_id
) => {
  try {
const token = localStorage.getItem("token");

    const res = await axios.post(
      `${BASE_URL}/circleMasterList`,
      {
        searchKey: searchValue,
        district_id: districtId,
        page: pageNo,
        per_page: perPage,
      },
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );

    setcircleList(res.data?.data || []);
    setPage(res.data.page || 1);
    setTotalRecords(res.data.total_records || 0);
    setTotalPages(
      Math.ceil(
        (res.data.total_records || 0) /
        (res.data.per_page || perPage)
      )
    );
  } catch (err) {
    console.log(err);
  }
};

    useEffect(() => { fetchCircleList(1); }, [perPage]);


  const loadDistricts = async () => {
      try {
        const res = await axios.post(`${BASE_URL}/districtMasterList`,
          {}, getAuthHeader());
        setDistricts(res.data?.data || []);
      } catch (err) {
        console.error("District load error:", err);

        if (err.response?.status === 401) {
          Swal.fire("Session Expired", "Please login again", "warning");
          localStorage.clear();
          navigate("/suda/login");
        } else if (err.response?.status === 422) {
          Swal.fire(
            "Validation Failed",
            err.response.data?.message || "Invalid request",
            "warning"
          );
        } else {
          Swal.fire("Alert!", "Failed to load districts", "error");
        }
      }
    };

    useEffect(() => {
        loadDistricts();
      }, []);


      const handleSubmitCircle = async () => {
  if (!formData.district_id || !formData.sub_division_id || !formData.circle_name) {
    Swal.fire("Validation Error", "All fields are required", "warning");
    return;
  }

  try {
const token = localStorage.getItem("token");

    const payload = {
      district_id: formData.district_id,
      sub_division_id: formData.sub_division_id,
      circle_name: formData.circle_name,
    };

    if (isEdit && editId) {
      payload.id = editId;
    }

    const res = await axios.post(
      `${BASE_URL}/circleMasterAddEdit`,
      payload,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    if (res.data?.status === true) {
      Swal.fire(
        "Success",
        isEdit ? "Circle updated successfully" : "Circle added successfully",
        "success"
      );

      setShowModal(false);
      setFormData({
        district_id: "",
        sub_division_id: "",
        circle_name: "",
      });

     fetchCircleList(page, filters.searchKey, filters.district_id);
    } else {
      Swal.fire("Alert", res.data?.message || "Something went wrong", "error");
    }
  } catch (err) {
    console.error(err);
    Swal.fire(
      "Alert",
      err.response?.data?.message || "Server error",
      "error"
    );
  }
};


  const openAddModal = () => {
    setIsEdit(false);
    setEditId(null);
    setFormData({ district_id: "" ,sub_division_id: "", circle_name: "" });
    setShowModal(true);
  };

  return (
    <div className="container mt-4" style={{ maxWidth: 1550 }}>
      {/* 🔷 HEADER */}
      <Card
        className="mb-4 border-0"
        style={{
          background: "linear-gradient(135deg, #E3F2FD, #ffffff)",
          borderRadius: "14px",
          boxShadow: "0 8px 25px rgba(21,101,193,0.15)",
        }}
      >
        <div
          className="px-4 py-3 text-white rounded-top"
          style={{ background: "linear-gradient(90deg, #0D47A1, #1565C1)" }}
        >
          <h5 className="mb-0 fw-bold d-flex align-items-center gap-2">
            <i className="fa-solid fa-circle-nodes"></i> Circle Master
          </h5>
        </div>

        <Card.Body className="px-4 py-4">
          <Row className="align-items-center">
            <Col md={3}>
              <Form.Group className="mb-3">
                <Form.Label className="fw-semibold">Search</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter Search"
                value={filters.searchKey}
                onChange={(e) =>
                  setFilters({ ...filters, searchKey: e.target.value })
                }
                style={{ borderRadius: "10px", border: "2px solid #1565C1" }}
              />
              </Form.Group>
            </Col>


            <Col md={3}>
                          <Form.Group className="mb-3">
                            <Form.Label className="fw-semibold text-dark">District</Form.Label>
                            <Form.Select
                              value={filters.district_id}
                              onChange={(e) =>
                                setFilters({ ...filters, district_id: e.target.value })
                              }
                              style={{
                                borderRadius: "10px",
                                border: "2px solid #1565C1",
                              }}
                            >
                              <option value="">Select District</option>
                              {districts.map((d) => (
                                <option value={d.id} key={d.id}>
                                  {d.name || d.district_name}
                                </option>
                              ))}
                            </Form.Select>
                          </Form.Group>
                        </Col>


                         <Col md={3}>
                         <Form.Group className="mb-3">
  <Form.Label className="fw-bold">
    Sub Division
  </Form.Label>

  <Form.Select
  value={filters.sub_division_id || ""}
  onChange={(e) =>
    setFilters({ ...filters, sub_division_id: e.target.value })
  }

   style={{
                                borderRadius: "10px",
                                border: "2px solid #1565C1",
                              }}
>
  <option value="">Select Sub Division</option>
  {filterSubDivisions.map((sd) => (
    <option key={sd.id} value={sd.id}>
      {sd.sub_division_name}
    </option>
  ))}
</Form.Select>

</Form.Group>
                         </Col>

            <Col md={3}>
                  <Form.Group className="mb-3">
                                  <Form.Label className="fw-semibold text-dark">Record Showing</Form.Label>

                      <Form.Select
                       style={{
                                      borderRadius: "10px",
                                      border: "2px solid #1565C1",
                                    }}
                        value={perPage}
                        onChange={(e) => {
                          const value = Number(e.target.value);
                          setPerPage(value);
                          setPage(1);

                        }}

                      >
                        <option value={10}>10 Per Page</option>
                              <option value={25}>25 Per Page</option>
                              <option value={50}>50 Per Page</option>
                              <option value={100}>100 Per Page</option>
                      </Form.Select>
                      </Form.Group>
                  </Col>

                  {/* ✅ BUTTONS */}
                        <Col md={4} className="d-flex gap-3 mt-3">
                          {/* SEARCH */}
                          <Button
                            className="w-50 fw-semibold text-white"
                            style={{
                              background: "#1565C1",
                              border: "none",
                              borderRadius: "10px",
                              transition: "0.3s",
                            }}
                            onMouseEnter={(e) => (e.target.style.background = "#0D47A1")}
                            onMouseLeave={(e) => (e.target.style.background = "#1565C1")}
                            onClick={() => fetchCircleList(1, filters.searchKey)}
                          >
                            <i className="fa-solid fa-magnifying-glass me-2"></i> Search
                          </Button>

                          {/* RESET */}
                          <Button
                            className="w-50 fw-semibold text-white"
                            style={{
                              background: "#E53935",
                              border: "none",
                              borderRadius: "10px",
                              transition: "0.3s",
                            }}
                            onMouseEnter={(e) => (e.target.style.background = "#D32F2F")}
                            onMouseLeave={(e) => (e.target.style.background = "#E53935")}
                            onClick={() => {
                              setFilters({ searchKey: "",district_id: "", });
                              setPage(1);
                              setPerPage(10);

  fetchCircleList(1, "", "");
                              }}
                          >
                            <i className="fa-solid fa-arrow-rotate-left me-2"></i> Reset
                          </Button>
                        </Col>
          </Row>
        </Card.Body>
      </Card>

      {/* ➕ ADD BUTTON */}
      <Button className="mb-3 px-4 text-white fw-semibold" onClick={openAddModal} style={addBtn}>
        <i className="fa-solid fa-circle-plus me-2"></i> Add Circle
      </Button>

      {/* 📄 TABLE */}
      <Card className="border-0" style={tableCard}>
        <Table bordered hover responsive striped>
          <thead>
            <tr>
              <th className="text-center" style={headerStyle}>SL No</th>
               <th className="text-center" style={headerStyle}>Circle</th>
               <th className="text-center" style={headerStyle}>District</th>
              <th className="text-center" style={headerStyle}>Sub Division</th>
              <th className="text-center" style={headerStyle}>Action</th>
            </tr>
          </thead>

          <tbody>
            {circleList.map((row, index) => (
              <tr key={row.id}>
                <td className="text-center">
          {(page - 1) * perPage + index + 1}
        </td>
                                <td className="text-center">{row.circle_name}</td>

                                <td className="text-center">{row.district_name}</td>

                <td className="text-center">{row.sub_division_name}</td>
                <td className="text-center">
                  <Button
  variant="warning"
  size="sm"
  className="d-flex gap-2 mx-auto fw-semibold"
  onClick={() => {
    setIsEdit(true);
    setEditId(row.id);
    fetchModalSubDivisions(row.district_id).then(() => {
    setFormData({
      district_id: row.district_id,
      sub_division_id: row.sub_division_id,
      circle_name: row.circle_name,
    });
    setShowModal(true);
  });
    setShowModal(true);
  }}
>
  <i className="fa-solid fa-pen-to-square"></i> Edit
</Button>

                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </Card>

      {
    totalPages > 1 && (
         <div className="d-flex justify-content-center mt-4">
        <nav>
            <ul className="pagination shadow-sm">

            <li className={`page-item ${page === 1 ? "disabled" : ""}`}>
                <button className="page-link" onClick={() => fetchCircleList(1)}>
                «
                </button>
            </li>

            {/* Prev */}
            <li className={`page-item ${page === 1 ? "disabled" : ""}`}>
                <button className="page-link" onClick={() => fetchCircleList(page - 1)}>
                ‹
                </button>
            </li>

            {/* Page Numbers */}
            {getPageNumbers().map((p) => (
                <li key={p} className={`page-item ${page === p ? "active" : ""}`}>
                <button className="page-link" onClick={() => fetchCircleList(p)}>
                    {p}
                </button>
                </li>
            ))}

            {/* Next */}
            <li className={`page-item ${page === totalPages ? "disabled" : ""}`}>
                <button className="page-link" onClick={() => fetchCircleList(page + 1)}>
                ›
                </button>
            </li>

            {/* Last */}
            <li className={`page-item ${page === totalPages ? "disabled" : ""}`}>
                <button className="page-link" onClick={() => fetchCircleList(totalPages)}>
                »
                </button>
            </li>

            </ul>
        </nav>
    </div>
    )
   }

      {/* MODAL */}
      <Modal show={showModal} onHide={() => setShowModal(false)} centered  backdrop="static"
  keyboard={false} >
        <Modal.Header closeButton style={{ background: "#1565C1", color: "white" }}>
          <Modal.Title>{isEdit ? "Edit Circle" : "Add Circle"}</Modal.Title>
        </Modal.Header>




        <Modal.Body>

            {/* DISTRICT */}
                  <Col md={12}>
                    <Form.Group className="mb-3">
                      <Form.Label>
                        District <span style={{ color: "red" }}>*</span>
                      </Form.Label>

                      <Form.Select
                        value={formData.district_id}
                        onChange={(e) =>
                          setFormData({ ...formData, district_id: e.target.value })
                        }
                      >
                        <option value="">Select District</option>
                        {districts.map((d) => (
                          <option key={d.id} value={d.id}>
                            {d.district_name}
                          </option>
                        ))}
                      </Form.Select>
                    </Form.Group>
                  </Col>
          <Form.Group className="mb-3">
  <Form.Label>
    Sub Division <span style={{ color: "red" }}>*</span>
  </Form.Label>

  <Form.Select
  value={formData.sub_division_id || ""}
  onChange={(e) =>
    setFormData({ ...formData, sub_division_id: e.target.value })
  }
>
  <option value="">Select Sub Division</option>
  {modalSubDivisions.map((sd) => (
    <option key={sd.id} value={sd.id}>
      {sd.sub_division_name}
    </option>
  ))}
</Form.Select>

</Form.Group>





          <Form.Group>
            <Form.Label>Circle Name <span style={{ color: "red" }}>*</span></Form.Label>
<Form.Control
  placeholder="Enter Circle Name"
  value={formData.circle_name}
  onChange={(e) =>
    setFormData({ ...formData, circle_name: e.target.value })
  }
/>
          </Form.Group>
        </Modal.Body>

        <Modal.Footer>
  <Button variant="secondary" onClick={() => setShowModal(false)}>
    Cancel
  </Button>
  <Button variant="success" onClick={handleSubmitCircle}>
    {isEdit ? "Update" : "Submit"}
  </Button>
</Modal.Footer>

      </Modal>
    </div>
  );
};

const headerStyle = {
  padding: "10px",
  fontWeight: "600",
  backgroundColor: "#edf7fe",
  borderBottom: "1px solid black",
  borderTop: "1px solid black",
  textAlign: "center",
};

const searchBtn = { background: "#1565C1", border: "none", borderRadius: "10px" };
const resetBtn = { background: "#E53935", border: "none", borderRadius: "10px" };
const addBtn = {
  background: "linear-gradient(135deg, #2E7D32, #66BB6A)",
  border: "none",
  borderRadius: "10px",
  padding: "10px 22px",
};
const tableCard = {
  background: "linear-gradient(145deg, #E3F2FD, #ffffff)",
  boxShadow: "0 10px 35px rgba(21,101,193,0.18)",
};

export default CircleMaster;
